import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "28",
  height: "28",
  fill: "none",
  viewBox: "0 0 28 28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "27",
      height: "27",
      x: ".5",
      y: ".5",
      fill: "#F2F4F7",
      rx: "3.5"
    }, null, -1),
    _createElementVNode("rect", {
      width: "27",
      height: "27",
      x: ".5",
      y: ".5",
      stroke: "#E4E6EB",
      rx: "3.5"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#667085",
      d: "M9.636 8.182h10.91c.401 0 .727.325.727.727V14h-1.455V9.636H9.636v2.182L6 8.91 9.636 6zm8.728 11.636H7.454a.727.727 0 0 1-.727-.727V14h1.455v4.364h10.182v-2.182L22 19.09 18.364 22z"
    }, null, -1)
  ]))]))
}
export default { render: render }